export default {
	add_new_product: "Añadir nuevo producto",
	brand: "Marca",
	detail_sold_products: "Detalles de los productos vendidos",
	for_more_than_one_product_click_on_the_add_new_product_button_and_fill_in_each_one: "Si hay más de un producto en la factura, haz click en \"Añadir nuevo producto\" y rellena los campos correspondentes.",
	insert_more_sales: "Incluir más ventas",
	insert_new_sale: "Incluir nueva venta",
	insert_sale: "Incluir Venta",
	invoice_number: "Número de la Factura/Boleta/Ticket",
	no_retailers_found: "Ninguna cadena minorista encontrada",
	no_stores_found: "Ninguna tienda encontrada",
	observation: "Observación",
	processor: "Procesador",
	product_type: "Tipo de Producto",
	products: "Productos",
	quantity_points: "Total de Puntos",
	quantity: "Cantidad de productos",
	remember_not_to_upload: "Acuérdate de no subir un número de factura ya informado anteriormente, pues no será aceptado dentro de una misma campaña.",
	remove_product: "Eliminar Producto",
	retailer: "Cadena Minorista",
	sale_date: "Fecha de la Venta",
	send_invoices_to_claim_your_points: "Informa tus ventas para sumar puntos en el programa. ¡Cuanto más vendes, más ganas! ",
	sku: "SKU/Código de producto",
	specify_below_the_product_sold_eligible_that_appears_on_the_invoice_sent: "Informa los detalles del producto que consta en la factura.",
	store: "Tienda",
	take_a_picture: "Sacar uma instantanea",
	the_note_number_has_already_been_sent_by_the_user_before: "El número de la Factura/Boleta/Ticket ya ha sido enviado por el usuario antes",
	tip: "Consejo",
	upload_invoice: "Incluir factura",
	your_sale_has_been_successfully_registered_and_your_points_were_credited_this_points_are_liable_to_be_auditable_before_your_prize_redeem_is_confirmed: "¡Tu venta ha sido registrada con éxito! Los puntos correspondientes han sido acreditados en tu cuenta y podrán ser auditados a cualquier momento.",
}